import React from 'react';
import { Form, Button, Card } from 'antd';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import { getUrlSearchParams, formatTimestamp, formatPrice } from 'utils/utils.js';
import UploadImage from 'components_business/UploadImage/Index.js';
import RelateSchoolsTable from '../components/RelateSchoolsTable.js';
import Skus from '../Modal/Skus.js';
import styles from './SaveOrUpdate.less';

const FormItem = Form.Item;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 5 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 15 },
  },
};

@connect(({ loading, merchantCommodityDetail }) => ({
  detail: merchantCommodityDetail.detail,
  receiveAccount: merchantCommodityDetail.receiveAccount,
  loading: loading.effects['merchantCommodityDetail/fetchDetail'] !== false,
}))
@Form.create()
export default class Query extends React.Component {
  constructor(props) {
    super(props);

    this.searchParams = getUrlSearchParams(props.location);
    this.handelBackToList = this.handelBackToList.bind(this);
    this.renderContent = this.renderContent.bind(this);
  }

  componentDidMount() {
    const { id } = this.searchParams;
    this.props.dispatch({
      type: 'merchantCommodityDetail/fetchDetail',
      id,
    });
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: 'merchantCommodityDetail/resetState',
    });
  }

  handelBackToList() {
    this.props.dispatch(routerRedux.goBack());
  }

  renderUploadImg() {
    const { images } = this.props.detail;
    const initialValue = images.split(',');

    return (
      <UploadImage
        type="render"
        description="默认第一张图为封面，最多上传5张"
        initialValue={initialValue}
      />
    );
  }

  renderContent() {
    const { detail, receiveAccount } = this.props;
    const account = receiveAccount.find(q => q.appId === detail.appId);

    return (
      <Form className={styles.root}>
        <FormItem {...formItemLayout} label="商品号">
          <div>{detail.commodityId}</div>
        </FormItem>

        <FormItem {...formItemLayout} label="商品名称">
          <div>{detail.name}</div>
        </FormItem>

        <FormItem {...formItemLayout} label="收款账号">
          <div>{account && account.name}</div>
        </FormItem>

        <FormItem {...formItemLayout} label="图片">
          <div>{detail.images ? this.renderUploadImg() : null}</div>
        </FormItem>

        <FormItem {...formItemLayout} label="规格">
          <div>
            <Skus type="render" />
          </div>
        </FormItem>

        {(!detail.skus || detail.skus.length === 0) && (
          <FormItem {...formItemLayout} label="价格设置（元）">
            <div>{formatPrice(detail.price)}</div>
          </FormItem>
        )}

        <FormItem {...formItemLayout} label="商品描述">
          <div
            className="description"
            dangerouslySetInnerHTML={(() => ({ __html: detail.description || '无' }))()}
          />
        </FormItem>

        <FormItem {...formItemLayout} label="关联上架学校">
          <div>
            <RelateSchoolsTable />
          </div>
        </FormItem>

        <FormItem {...formItemLayout} label="商品更新时间">
          <div>{formatTimestamp(detail.gmtModify)}</div>
        </FormItem>

        <FormItem className="operation-button-wrap">
          <Button onClick={this.handelBackToList}>返回</Button>
        </FormItem>
      </Form>
    );
  }

  render() {
    const { loading } = this.props;
    return (
      <Card bordered={false} loading={loading}>
        {this.renderContent(this)}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Commodity/Detail/Query.js